import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Auth } from "@air/api";
import { FormikField } from "@air/formik-field";
import { Button } from "@air/primitive-button";
import { Input } from "@air/primitive-input";
import { getRegistrationEmailValidationSchema } from "@air/utils-auth";
import { Formik } from "formik";
import { useState } from "react";
import Form from "~/components/Form";
import { Routes } from "~/constants/routes";
import { QueryParamNames } from "~/constants/search";
import { SIGN_UP_CONTINUE_BUTTON, SIGN_UP_EMAIL_INPUT } from "~/constants/testIDs";
import { pushWithExistingQuery } from "~/utils/PathUtils";
const _SignUpValidationSchema = getRegistrationEmailValidationSchema();
export const EmailSignUpChecker = (param)=>{
    let { defaultEmail, disabled, onSuccess, onError } = param;
    const validationSchema = getRegistrationEmailValidationSchema(defaultEmail);
    const [isSubmitting, setSubmitting] = useState(false);
    return /*#__PURE__*/ _jsx(Formik, {
        enableReinitialize: true,
        initialValues: validationSchema.cast({}),
        validationSchema: validationSchema,
        onSubmit: async (values)=>{
            try {
                setSubmitting(true);
                const { exists } = await Auth.isUserRegistered(values.email);
                if (exists) {
                    pushWithExistingQuery({
                        path: Routes.auth.login,
                        newQuery: {
                            [QueryParamNames.existingEmail]: values.email
                        }
                    });
                } else {
                    onSuccess(values);
                }
            } catch (error) {
                if (onError) {
                    onError(error);
                }
            } finally{
                setSubmitting(false);
            }
        },
        children: /*#__PURE__*/ _jsxs(Form, {
            children: [
                /*#__PURE__*/ _jsx(FormikField, {
                    id: "email",
                    className: "mb-6",
                    component: /*#__PURE__*/ _jsx(Input, {
                        type: "email",
                        placeholder: "olivia@companyname.com",
                        autoComplete: "username",
                        size: "large",
                        "data-testid": SIGN_UP_EMAIL_INPUT,
                        disabled: disabled
                    }),
                    label: "Work email *",
                    name: "email"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    className: "w-full",
                    appearance: "filled",
                    size: "large",
                    color: "blue",
                    type: "submit",
                    "data-testid": SIGN_UP_CONTINUE_BUTTON,
                    disabled: disabled,
                    isLoading: isSubmitting,
                    children: "Continue"
                })
            ]
        })
    });
};
